const defaultStore = {
  data: {},
  getItem(key) {
    return this.data[key];
  },
  setItem(key, value) {
    this.data[key] = value;
  },
  clear() {
    this.data = {};
  },
  removeItem(key) {
    this.data[key] = undefined;
  },
};

const local = window.localStorage || defaultStore;
const session = window.sessionStorage || defaultStore;

/**
 * @function
 * @name getLocalStorageItem
 * @param {string} key
 * @returns {(string|Object)} 찾고자 하는 값이 없을 경우 null이 return 된다.
 */
export const getLocalStorageItem = (key) => local.getItem(key);

/**
 * @function
 * @name setLocalStorageItem
 * @param {string} key
 * @param {string} value
 */
export const setLocalStorageItem = (key, value) => local.setItem(key, value);

/**
 * @function
 * @name removeLocalStorageItem
 * @param {string} key
 */
export const removeLocalStorageItem = (key) => local.removeItem(key);

/**
 * @function
 * @name clearLocalStorageItems
 */
export const clearLocalStorageItems = () => local.clear();

/**
 * sessionStorage관련 함수들도 사용법은 동일.
 */

export const getSessionStorageItem = (key) => session.getItem(key);
export const setSessionStorageItem = (key, value) => session.setItem(key, value);
export const removeSessionStorageItem = (key) => session.removeItem(key);
export const clearSessionStorageItems = () => session.clear();
